import { Controller } from 'stimulus';
import sanitizer from '../mixins/coupon_code_sanitizer';

const API_ENDPOINT = '/app/api/v1/coupons';

function findFormValue(att_type) {
  const formEl = document.querySelector(
    'form[data-controller="subscription-input-form"]'
  );

  if (formEl === null) {
    return '';
  }

  const attEl = formEl.querySelector(`input#subscription_form_${att_type}`);

  if (attEl === null) {
    return '';
  }

  return attEl.value;
}

function defaultHeaders() {
  const csrfTokenEl = document.querySelector(
    'input[name="authenticity_token"]'
  );
  if (csrfTokenEl && csrfTokenEl.value) {
    return {
      'X-CSRF-Token': csrfTokenEl.value,
    };
  }

  return {};
}

export default class extends Controller {
  static targets = ['price'];

  /* eslint-disable no-undef */
  get logger() {
    try {
      return (window.dtrum && typeof window.dtrum.reportError === 'function') ? window.dtrum : null;
    } catch (e) {
      return null;
    }
  }
  /* eslint-enable no-undef */

  async applyCoupon() {
    const couponEl = document.querySelector("*[data-controller='coupon-code']");
    if (couponEl === null) {
      return Promise.resolve(false);
    }
    const userCoupon = couponEl.attributes['data-coupon-code-user-coupon'];
    if (userCoupon === null) {
      return Promise.resolve(false);
    }
    const sanitizedCouponInputValue = sanitizer(userCoupon.value);
    const productSlug = findFormValue('product_slug');
    const planSlug = findFormValue('plan_slug');
    const childQuantity = findFormValue('quantity');

    try {
      const response = await fetch(
        `${API_ENDPOINT}/${sanitizedCouponInputValue}/apply?product=${productSlug}&plan=${planSlug}&quantity=${childQuantity}`,
        {
          headers: Object.assign(defaultHeaders(), {
            'Content-Type': 'application/json',
          }),
        }
      );

      if (!response.ok) {
        this.updatePrice();
        throw Error(`Request rejected: url: ${response.url}, status: ${response.status} ${response.statusText}`);
      }

      const apiResponse = await response.json();
      const newPrice = apiResponse.price;
      this.updatePrice(newPrice);

      return Promise.resolve(true);
    } catch (error) {
      this.logError(error, 'Error applying coupon in subscription_details_controller');
      return Promise.resolve(false);
    }
  }

  logError(details, errorMessage) {
    if (this.logger) {
      this.logger.reportError(`${errorMessage}: ${details}`);
    }
  }

  updatePrice(newPrice) {
    if (this.hasPriceTarget) {
      this.priceTarget.innerText =
        newPrice || this.priceTarget.dataset.retailAmount;
    }
  }
}
